import React, { FC, useContext } from 'react';

import shelterIcon from 'assets/images/partneringShelters.svg';
import { capitalizeEveryWord } from 'helpers/capitalizeEveryWord';
import { Shelter } from 'types/Shelter';
import { DataContext } from 'hooks/HeaderContext';
import classNames from 'classnames';


interface IShelterCardProps {
    shelter: Shelter;
}


const ShelterCard: FC<IShelterCardProps> = ({ shelter }) => {

    const {
        institutionSearchText
    } = useContext(DataContext);


    const populateShelterPhone = (phoneNum: string) => {
        if (!phoneNum) return
        let isNum = (/\d+/i).test(phoneNum)
        if (isNum) {
            return <div className='mt-2 text-muted'>{phoneNum}</div>
        }
    }

    const populateUrl = (url: string) => {
        if (!url.startsWith('http')) return 'https://' + url;
        else return url;
    }

    return (
        <div className='col'>
            <div className={classNames('card shadow-sm h-100 shelter-card rounded-3',
                { 'matching-shelter ': institutionSearchText && institutionSearchText.label === shelter.name }
            )}>
                <div className='card-body'>
                    <div className='card-title d-flex align-items-center'>
                        <img src={shelterIcon} style={{ maxWidth: '30%' }} alt={`${shelter.name}, ${shelter.cityStateZip}, ${shelter.addressOne}, ${shelter.phone}`} />
                        <p className='fw-bold ms-2 mb-0' >{capitalizeEveryWord(shelter.name)}</p>
                    </div>
                    <div className='card-text'>
                        <div className="">{capitalizeEveryWord(shelter.addressOne, 'PO')}</div>
                        {shelter.addressTwo && shelter.addressTwo !== '' &&
                            <div className="">{capitalizeEveryWord(shelter.addressTwo, 'PO')}</div>
                        }
                        <div className="text-truncate">{shelter.cityStateZip}</div>
                        {populateShelterPhone(shelter.phone)}
                    </div>
                </div>
                <div className='text-center p-2'>
                    <a role='button'
                        href={shelter.url ? populateUrl(shelter.url) : ''}
                        target='_blank'
                        rel='noreferrer'
                        className='btn btn-outline-primary rounded-pill'
                    >
                        View adoption site
                    </a>

                </div>


            </div>
        </div>


    )
}

export default ShelterCard;




















